(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["orblink-support-drawer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeSupportDrawer = (root) => {
      if (!root || root.dataset.initialized === 'true') return;

      const trigger = root.querySelector('[data-orblink-support-open]');
      const dialog = root.querySelector('[data-orblink-support-dialog]');
      const closeButton = root.querySelector('[data-orblink-support-close]');

      if (!trigger || !dialog || !closeButton) return;
      root.dataset.initialized = 'true';

      const openDialog = () => {
        if (!dialog.open) {
          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }
        }
        trigger.setAttribute('aria-expanded', 'true');
      };

      const closeDialog = () => {
        if (typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus({ preventScroll: true });
      };

      trigger.addEventListener('click', openDialog);
      closeButton.addEventListener('click', closeDialog);

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });

      dialog.addEventListener('close', () => {
        trigger.setAttribute('aria-expanded', 'false');
      });

      const status = dialog.querySelector('[data-orblink-support-status]');
      if (status) {
        openDialog();
        requestAnimationFrame(() => status.focus({ preventScroll: false }));
      }
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-orblink-support]').forEach(initializeSupportDrawer);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:select', (event) => {
      const root = event.target.querySelector('[data-orblink-support]');
      if (!root) return;
      initializeSupportDrawer(root);
      root.querySelector('[data-orblink-support-open]')?.click();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
